import React, { Suspense, Component } from 'react';
import UserProvider from "global/context/user/UserProvider";
import ShowLoading from 'global/components/ShowLoading';
const framework = process.env.REACT_APP_FRAMEWORK;
let ContainerSystem = null;
if (framework == "WEB") {
    ContainerSystem = React.lazy(() => import("global/components/Page/CtnSysWeb")
        .then((mod) => {
            console.log("Cargo  Web", framework)
            return { default: mod.default };
        }));
}

else if (!framework || framework == "ARCHI") {
    ContainerSystem = React.lazy(() => import("global/components/Page/CtnSysArchi")
        .then((mod) => {
            return { default: mod.default };
        }));
}
else {
    ContainerSystem = React.lazy(() => import("" + framework)
        .then((mod) => {
            console.log("Cargo  ", framework)
            return { default: mod.default };
        }));
}
//import configureAppStore from "global/config/store/configureStore";
//const store = configureAppStore();
class Pagina extends Component {
    constructor(props) {
        super(props);
        this.data = props;
    }
    //fallback={<div>Cargando sistema...</div>}
    //<UserProvider store={store}>
    render = () => (<Suspense fallback={<ShowLoading />}>
        <UserProvider >
            <ContainerSystem />
        </UserProvider>
    </Suspense>)
}

export default Pagina;
